import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";

import { useDialogsProvider } from "2g-dialogs-provider";
import ZpracDialog from "2g-zprac-dialog";
import { actions as formActions, useFieldValue } from "2g-form";
import { dispatchModuleAction } from "2g-utils-redux";

import { ADMIN } from "b2b/api/paths";
import { useTypyZdroje } from "b2b/api/hooks";
import { PATHS } from "b2b/constants";
import { useRedirect } from "b2b/hooks";
import useMessages from "./i18n/useMessages";

export const FORM_MODULE_KEY = "zdrojEditaceForm";

export default function useZdrojEditaceWidget({ zdroj }) {
  const { saveDialogTitle, deleteDialogTitle } = useMessages();
  const { showDialog, hideDialog } = useDialogsProvider();
  const isExclusive = useFieldValue("exkluzivita", FORM_MODULE_KEY);
  const dispatch = useDispatch();
  const redirect = useRedirect();
  const { reload: reloadZdroje } = useTypyZdroje();

  useEffect(() => {
    zdroj &&
      dispatchModuleAction(
        dispatch,
        FORM_MODULE_KEY,
        formActions.setValues(zdroj)
      );
  }, [zdroj]);

  useEffect(() => {
    if (!isExclusive) return;
    dispatchModuleAction(
      dispatch,
      FORM_MODULE_KEY,
      formActions.setValue("maxPocetPozadavku", 1)
    );
  }, [isExclusive]);

  const redirectToZdroje = useCallback(() => {
    redirect(PATHS.ADMINISTRACE.ZDROJE);
  }, [redirect]);

  const handleSuccess = useCallback(() => {
    hideDialog();
    redirectToZdroje();
    reloadZdroje();
  }, [hideDialog, redirectToZdroje, reloadZdroje]);

  const handleSubmit = useCallback(
    ({ values, submitter }) => {
      showDialog(ZpracDialog, {
        url: ADMIN.zdroj(values.id),
        method: values.id ? "put" : "post",
        payload: values,
        title: saveDialogTitle(),
        onClose: hideDialog,
        onSuccess: handleSuccess
      });
    },
    [showDialog, handleSuccess]
  );

  const handleDelete = useCallback(() => {
    showDialog(ZpracDialog, {
      url: ADMIN.zdroj(zdroj.id),
      method: "delete",
      title: deleteDialogTitle(),
      onClose: hideDialog,
      onSuccess: handleSuccess
    });
  }, [zdroj?.id, handleSuccess]);

  return {
    formModuleKey: FORM_MODULE_KEY,
    onSubmit: handleSubmit,
    onCancel: redirectToZdroje,
    onDelete: handleDelete,
    maxPocetPozadavkuDisabled: isExclusive
  };
}
